import { AxiosRequestConfig } from "axios";
import { instance } from "../api-instance";

export const ScanApi = {
  documentCheck: (
    {
      applicationId,
      isReturnData = true,
    }: {
      applicationId: string;
      isReturnData?: boolean;
    },
    options: AxiosRequestConfig
  ): Promise<unknown[]> =>
    instance
      .post(`document/check`, { applicationId, isReturnData }, options)
      .then((res) => {
        const categories = res?.data?.categories;
        if (!categories) return [];

        const sorted = categories
          ? [...categories].sort((a, b) => (a.id > b.id ? 1 : -1))
          : [];

        return sorted;
      }),

  saveScan(data: unknown): Promise<unknown> {
    return instance
      .post(`document/save`, data, {
        headers: {
          Accept: "application/json ,text/plain, */*",
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => res.data);
  },

  removeScan(id: string): Promise<unknown> {
    return instance
      .post(`document/remove`, { fileId: id })
      .then((res) => res.data);
  },

  checkIfScanIsRequired(
    data: unknown,
    options: AxiosRequestConfig
  ): Promise<unknown> {
    return instance
      .post(`document/isRequiredScan`, data, options)
      .then((res) => res.data);
  },

  checkIsScanCopySign(data: unknown): Promise<unknown> {
    return instance
      .post(`document/isScanCopySign`, data)
      .then((res) => res.data);
  },

  signFiles(data: unknown): Promise<unknown> {
    return instance.post(`document/signFiles`, data).then((res) => res.data);
  },
};
